import React, { useState, useEffect } from 'react';
import API from '../../../Services/BaseService';
import { useHistory, useLocation, useParams } from "react-router-dom";
import CommonPopup from '../../../Component/CommonPopup/CommonPopup';
import "../../../Component/CommonPopup/commonPopup.css"
import { useDispatch, useSelector } from 'react-redux';
import ls from 'local-storage';
/* import { Button } from "antd"; */
import { Modal, Button } from 'react-bootstrap';

const ViewIfInfoPopup = (props) => {
    const history = useHistory();

    const [isCommonPopupOpen, setIsCommonPopupOpen] = useState(false);
    const [popupTitle, setPopupTitle] = useState("");
    const [popupMsg, setPopupMsg] = useState("");
    const [popupType, setPopupType] = useState("");
    const [popupActionType, setPopupActionType] = useState("");
    const [popupActionValue, setPopupActionValue] = useState("");
    const [popupActionPath, setPopupActionPath] = useState("");
    const [alertmessage, setAlertMessage] = useState("");
    const [alerttitle, setAlertTitle] = useState("");
    const [alertimg, setAlertImg] = useState("");
    const [comments, setComments] = useState(props.viewIfId);
    const [commentsError, setCommentsError] = useState();
    const adminData = useSelector(state => state.LoginReducer.payload);
    const [togglePopupOpen, setTogglePopupOpen] = useState(true);
    const [notesList, setNotesList] = useState("");
    const toggleCommonPopup = () => {
        setIsCommonPopupOpen(!isCommonPopupOpen);
    }
    const saveAdd = () => {

        setCommentsError("")

        if (!comments) {
            setCommentsError("Notes is required")
            return;
        }
        else if (comments.length > 500) {
            setCommentsError("Notes must not exceed 500 characters")
            return;
        }

        const recentlyAddednewvalue = [...notesList, comments]
        setNotesList([...notesList, comments])
        // props.addIF(recentlyAddednewvalue)
        setComments(" ")
        console.log("notesList======", notesList)
        console.log("comments======", comments)
        console.log("recentlyAddednewvalue item======", recentlyAddednewvalue)

    }
    const handleClose = () => {
        setTogglePopupOpen(false);
        props.toggle(); 
    }

    return (
        <Modal show={togglePopupOpen} onHide={handleClose} centered>
            <Modal.Header className="Terms-login">
                <Modal.Title>View IF Info</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <label htmlFor="buyer" className="form-label required">IF Info</label>
                <textarea className="form-control mt-3" type="text" placeholder=""
                    aria-label="default input example" disabled
                    value={comments == "null" || comments == null ||
                        comments == "undefined" || comments == undefined || comments == "" ? "" : comments} />
                         <div className="Sellernotes">
                            <Button className="cta-btn" onClick={handleClose}>Close</Button>
                        </div>
            </Modal.Body>
        </Modal>
    )
}
export default ViewIfInfoPopup